import React, { useState, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Icon, Spinner } from '@amzn/awsui-components-core';
import { redirectToUserProfilePage } from './APGLUserProfileUtils';

const ManageUserProfileLink = () => {
  const [isManageUserProfileLinkLoading, setIsManageUserProfileLinkLoading] = useState(false);

  const appContext = useContext(AppContext);
  // @ts-expect-error TS2339 - strict migration
  const { userProfile } = appContext.authnInfo;

  const handleManageUserProfile = async () => {
    setIsManageUserProfileLinkLoading(true);
    const { userId } = userProfile;
    await redirectToUserProfilePage(userId);
    setIsManageUserProfileLinkLoading(false);
  };

  return (
    <div onClick={handleManageUserProfile} className="home-page-banner-action-link">
      Manage your APG Library profile <Icon name="angle-right" size="small" variant="inverted" />
      {isManageUserProfileLinkLoading ? <Spinner /> : null}
    </div>
  );
};

export default ManageUserProfileLink;
